import React, { useState } from 'react';
import './Aelectricinjecton.css';
import electbanr1 from '../../../imgs/electbanr1.webp';
import electbanr2 from '../../../imgs/electbanr2.webp';
import electbanr3 from '../../../imgs/electbanr3.webp';
import electbanr4 from '../../../imgs/electbanr4.webp';
import Reqprodcte from "../../../components/Reqprodcte"; 


const images = [
  { src: electbanr1 },
  { src: electbanr2 },
  { src: electbanr3 },
  { src: electbanr4 },
];

const Aelectricinjecton = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((current + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((current - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrent(index);
  };

  return (
    <div className="electric-main-container">
      {/* Left: Slideshow */}
      <div className="electric-slideshow">
        {images.map((img, index) => (
          <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
            {index === current && (
              <>
                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image"data-aos="fade-down-right" />
              </>
            )}
          </div>
        ))}
        <a className="prev" onClick={prevSlide}>&#10094;</a>
        <a className="next" onClick={nextSlide}>&#10095;</a>

        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={index === current ? "dot active" : "dot"}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* Right: Text Section */}
      <div className="electric-text">
        <h2>All Electric Injection Molding Machine</h2>
        <h3>JE SERIES</h3>
        <p>
          Powerjet All Electric Injection Molding Machine with servo drives is suitable for
          manufacturing high precision products like: medical appliances, optical lens, gears,
          digital accessories and so on.
        </p>
        <ul>
          <li><strong>Clamping Force:</strong> 600~3500(KN)</li>
          <li><strong>Driving System:</strong> All Electric</li>
          <li><strong>Motor Type:</strong> Servo</li>
          <li><strong>Applications:</strong> Precision Plastic Product Like: Medical Appliances, Optical Lens, Gears, Digital Accessories</li>
        </ul>
 <div className='stnd'>
                            <Reqprodcte />
                        </div>      </div>
    </div>
  );
};

export default Aelectricinjecton;
